var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, CustomElement, html, ifDefined, nothing } from '@sick-davinci/ce-decorators';
import { Icon } from '../icon/Icon';
import { IconRef } from '../icon/IconRef';
import { style } from './Link.style';
/**
 * A link is an interactive element that suggests it can be clicked.
 * Links are used to allow users to navigate through content such as web pages, files or images.
 * When clicking the link, users are automatically directed to the linked page or object.
 * 
 * A DaVinCI link is a simple wrapper around the `a` element.
 * 
 * Style can be influenced using the `inverted`, `inside-text` and `icon*` attributes.
 * 
 * @example
 * ```html
 * <davinci-link href="https://www.sick.com" target="_blank">Homepage</davinci-link>
 * 
 * <davinci-link icon="action/favorite" href="#">Favorite!</davinci-link>
 * ```
 * @slot { * } content of the link
 */

export let Link = (_dec = Component({
  style: [style],
  tag: 'davinci-link',
  dependencies: [Icon, IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = (_temp = class Link extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "href", _descriptor, this);

    _initializerDefineProperty(this, "target", _descriptor2, this);

    _initializerDefineProperty(this, "download", _descriptor3, this);

    _initializerDefineProperty(this, "icon", _descriptor4, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor5, this);

    _initializerDefineProperty(this, "inverted", _descriptor6, this);

    _initializerDefineProperty(this, "insideText", _descriptor7, this);
  }

  get hasIcon() {
    return this.icon || this.iconSrc;
  }

  render() {
    return html`
      <a class="link"
        href=${ifDefined(this.href)}
        target=${ifDefined(this.target)}
        download=${ifDefined(this.download)}
      >
        ${this._renderIcon()}
        <div class=text>
          <slot></slot>
        </div>
      </a>
    `;
  }

  _renderIcon() {
    if (this.iconSrc) {
      return html`<davinci-icon-ref src=${this.iconSrc}></davinci-icon-ref>`;
    }

    if (this.icon) {
      return html`<davinci-icon icon=${this.icon}></davinci-icon>`;
    }

    return nothing;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "href", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "target", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "download", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "inverted", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "insideText", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
//# sourceMappingURL=Link.js.map